// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"717cc4e9266c7547c16e","678":"d4ce0c63c857459fb06b"}[chunkId] + ".js";
};